import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { hasAssignments } from '@/shared/components/security/HasAssignments';

import messages from '../invoiceStreamMessages';

export default class UpdateInvoiceStreamPriceGridModal extends Component {
  state = {
    priceGridId: undefined,
    updateRelation: true,
    resetInvoiceStreams: false,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  isFormInvalid = () => {
    const { priceGridId, updateRelation } = this.state;

    if (updateRelation && !priceGridId) {
      return true;
    }

    return false;
  };

  onSave = () => {
    const { priceGridId, updateRelation, resetInvoiceStreams } = this.state;

    const { onSave } = this.props;

    return onSave({ priceGridId, updateRelation, resetInvoiceStreams });
  };

  updateRelationChanged = e => {
    this.setState({ updateRelation: e.target.value === 'true' });
  };

  render() {
    const { show, onClose, intl, priceGrids } = this.props;
    const { priceGridId, updateRelation, resetInvoiceStreams } = this.state;
    const showAdvancedOptions = hasAssignments();

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.UpdatePriceGrid)}
        show={show}
        onClose={onClose}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          {showAdvancedOptions ? (
            <div className="form-group">
              <div className="col-sm-8 col-sm-offset-4">
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="updateRelation"
                      id="updateRelation1"
                      value="true"
                      checked={!!updateRelation}
                      onChange={this.updateRelationChanged}
                    />
                    {intl.formatMessage(messages.UpdatePriceGridOnSelectedRelations)}
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="updateRelation"
                      id="updateRelation2"
                      value="false"
                      checked={!updateRelation}
                      onChange={this.updateRelationChanged}
                    />
                    {intl.formatMessage(messages.UpdatePriceGridOnSelectedInvoiceStreams)}
                  </label>
                </div>
              </div>
            </div>
          ) : null}

          <div className="form-group">
            <label className="control-label col-sm-4">
              {intl.formatMessage(messages.PriceGrid)}
            </label>
            <div className="col-sm-5">
              <select
                onChange={e => this.setState({ priceGridId: e.target.value })}
                className="form-control"
                value={priceGridId || ''}
              >
                {typeof priceGridId === 'undefined' && (
                  <option value="">{intl.formatMessage(messages.SelectPriceGrid)}</option>
                )}
                {!updateRelation && (
                  <option value="">{intl.formatMessage(messages.UseRelationSetting)}</option>
                )}
                {priceGrids.map(priceGrid => (
                  <option key={priceGrid.key} value={priceGrid.key}>
                    {priceGrid.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {showAdvancedOptions && updateRelation ? (
            <div className="form-group">
              <div className="col-sm-8 col-sm-offset-4">
                <label className="react-toggle-wrapper margin5T">
                  <Toggle
                    checked={resetInvoiceStreams}
                    onChange={e => this.setState({ resetInvoiceStreams: !!e.target.checked })}
                  />
                  <span className="label-text">
                    {intl.formatMessage(messages.AlsoResetPriceGridOnSelectedInvoiceStreams)}
                  </span>
                </label>
              </div>
            </div>
          ) : null}
        </div>
      </OkCancelModal>
    );
  }
}
